var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect, useState } from 'react';
import { WorkspaceBarUtils } from '../utils';
export const useWorkspaceBar = () => {
    _react_refresh_temp_1();
    const [isWorkspaceBarExpanded, setIsWorkspaceBarExpanded] = useState(WorkspaceBarUtils.getExpandedState());
    useEffect(() => {
        WorkspaceBarUtils.setExpandedState(isWorkspaceBarExpanded);
    }, [isWorkspaceBarExpanded]);
    return { isWorkspaceBarExpanded, setIsWorkspaceBarExpanded };
};
_react_refresh_temp_1(useWorkspaceBar, "FHMkvfNa1VIwcEpYJVuqKqIX2hI=");
